/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Filter, FilterValue } from "@Internal/Contracts";
import { CustomValue, SelectionFilter } from "@Internal/Models";

let defaultFilters: Filter[] = [];

/* Active = coupons still redeemable (enabled and not past their expiry date), Expired = disabled
   (e.g. stopped) or past their expiry date. */
function getStatuses(): FilterValue[] {
    return [
        new CustomValue<string>( $t( "COUPONS_statusActive" ), "Active" ),
        new CustomValue<string>( $t( "COUPONS_statusExpired" ), "Expired" )
    ];
}

function Get(): Filter[] {
    if( defaultFilters.length === 0 )
        defaultFilters = [
            new SelectionFilter(
                "Status",
                $t( "COUPONS_filterStatus" ),
                getStatuses(),
                $t( "COUPONS_filterStatusPlaceholder" )
            )
        ];

    return defaultFilters;
}

export default {
    Get
};
